import { render } from "./Magasins.vue?vue&type=template&id=f529c0d6"
import script from "./Magasins.vue?vue&type=script&lang=js"
export * from "./Magasins.vue?vue&type=script&lang=js"
script.render = render

export default script